import axios from "axios";

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

adminApi.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      await adminApi.post("/auth/refresh");
      return adminApi(original);
    }
    return Promise.reject(error);
  }
);

export const errorText = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg ?? "").filter(Boolean).join(" ");
  return detail?.msg ?? String(detail);
};
